import { render, staticRenderFns } from "./CartsNotification.vue?vue&type=template&id=425f4e3a&scoped=true"
import script from "./CartsNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartsNotification.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CartsNotification.vue?vue&type=style&index=0&id=425f4e3a&prod&lang=scss&scoped=true"
import style1 from "./CartsNotification.vue?vue&type=style&index=1&id=425f4e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f4e3a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CSnackbar: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSnackbar/CSnackbar.vue').default})
